import React from "react";
import { Box, Typography } from "@mui/material";
import { BULK_MARK_COLORS } from "./bulkMarkColors";
import { type BulkAcquisitionBreakdown } from "../types";

// 確認ダイアログの内訳表と同じ語・同じ順
const ROWS = [
  { key: "newPictureCount", label: "新規取得" },
  { key: "acquiredPictureCount", label: "取得済登記" },
  { key: "reusePictureCount", label: "リユース登記" },
] as const satisfies ReadonlyArray<{
  key: keyof BulkAcquisitionBreakdown;
  label: string;
}>;

/**
 * チェック済み書類を現在の取得方法・経過日数で振り分けた内訳。
 * 確認ダイアログを開かずに課金対象（新規取得）の件数が分かるよう常時出す
 */
export const BulkSelectionBreakdown: React.FC<{
  breakdown: Pick<BulkAcquisitionBreakdown, (typeof ROWS)[number]["key"]>;
}> = ({ breakdown }) => (
  <Box
    component="dl"
    sx={{
      display: "flex",
      alignItems: "center",
      gap: 2,
      m: 0,
      fontVariantNumeric: "tabular-nums",
    }}
  >
    {ROWS.map(({ key, label }) => (
      <Box key={key} sx={{ display: "flex", alignItems: "baseline", gap: 0.5 }}>
        <Typography component="dt" variant="body2" color="text.secondary">
          {label}
        </Typography>
        <Typography
          component="dd"
          variant="body2"
          sx={{
            m: 0,
            fontWeight: 600,
            // 課金対象だけ未取得の印と同じ色にして目に入るようにする
            color:
              key === "newPictureCount" && breakdown[key] > 0
                ? BULK_MARK_COLORS.unacquiredLine
                : "text.primary",
          }}
        >
          {breakdown[key].toLocaleString()}
        </Typography>
      </Box>
    ))}
  </Box>
);
